import classNames from 'classnames'
import { forwardRef } from 'react'

import type { InputHTMLAttributes, Ref } from 'react'

import Label from '~/components/Label'

import './styles.scss'

export interface Props {
  className?: string
  label: string
  name: string
}

const RadioInput = forwardRef(
  (
    { className, label, name, ...props }: Props & InputHTMLAttributes<HTMLInputElement>,
    ref?: Ref<HTMLInputElement>
  ) => {
    return (
      <div className={classNames('radio-input-component', className)}>
        <input {...props} className="input" name={name} ref={ref} type="radio" />
        <Label label={label} />
      </div>
    )
  }
)

RadioInput.displayName = 'RadioInput'

export default RadioInput
